import type { Currency } from "@/helpers/currency";

type CurrencyStringProps = {
  code: string;
  val: number | string;
  currencies: { [code: string]: Currency };
  tenantCurrencyLocale: string;
  tenantCurrencyCode: string;
};

export function formatCurrencyString({
  code,
  val,
  currencies,
  tenantCurrencyLocale,
  tenantCurrencyCode,
}: CurrencyStringProps): string {
  const value = typeof val === "number" ? val : Number(val);
  if (code && code in currencies) {
    return value.toLocaleString(currencies[code].locale, {
      style: "currency",
      currency: code,
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    });
  }
  return value.toLocaleString(tenantCurrencyLocale, {
    style: "currency",
    currency: code || tenantCurrencyCode,
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });
}
